import { reset, submit } from 'redux-form'

export const resetForm = formName => {
    return dispatch => dispatch(reset(formName))
}

export const submitForm = formName => {
    return dispatch => dispatch(submit(formName))
}



// WEBPACK FOOTER //
// ./src/ducks/Forms.js